import React from "react"
import Paper from "@material-ui/core/Paper"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"

import OutlinedInput from "@material-ui/core/OutlinedInput"
import TextField from "@material-ui/core/TextField"
import InputAdornment from "@material-ui/core/InputAdornment"
import Grid from "@material-ui/core/Grid"

const useStyles = makeStyles((theme) => ({
  paddedBox: {
    padding: theme.spacing(4, 4),
  },
}))

const IngredientListScaler = ({ siteTitle, toggleDrawer }) => {
  const classes = useStyles()

  const sumIngredientsAmounts = (ingredientsList) => {
    return ingredientsList
      .filter((item) => item.amount)
      .map((item) => item.amount)
      .reduce((total, amount) => total + amount, 0)
  }

  const scaleIngredientsListItems = (ingredientsListItems, desiredAmount) => {
    const totalAmount = sumIngredientsAmounts(ingredientsListItems)
    const scalingFactor = desiredAmount / totalAmount
    const newIngredientsList = ingredientsListItems.map((listItem) => {
      return {
        ...listItem,
        amount: listItem.amount
          ? Math.round(listItem.amount * scalingFactor)
          : listItem.amount,
      }
    })

    return newIngredientsList
  }

  const renderIngredientsList = (ingredientsList) => {
    return ingredientsList
      .map((item) => {
        if (isNaN(item.amount)) {
          return `${item.name}`
        } else {
          return `${item.amount}${item.name}`
        }
      })
      .join("\n")
  }

  const extractIngredientsList = (rawIngredientsList) => {
    return rawIngredientsList.split("\n").map((line) => {
      const groups = line
        .trim()
        .match(/^((?<amount>[0-9]+)|[0-9]*)(?<name>.*)/).groups

      return {
        amount: parseFloat(groups.amount),
        name: groups.name,
      }
    })
  }

  const defaultIngredientsList = "100g chocolate\n50g hazelnut paste"
  const defaultTotalAmount = "150"
  const defaultDesiredAmount = "250"
  const defaultScaledIngredientsList = "167g chocolate\n83g hazelnut paste"

  const [state, setState] = React.useState({
    totalAmount: defaultTotalAmount,
    ingredientsList: defaultIngredientsList,
    scaledIngredientsList: defaultScaledIngredientsList,
    desiredAmount: defaultDesiredAmount,
  })

  const handleIngredientListChange = (event) => {
    const ingredientsListRaw = event.target.value
    const ingredientsList = extractIngredientsList(ingredientsListRaw)
    const totalAmount = sumIngredientsAmounts(ingredientsList)
    const newIngredientsList = scaleIngredientsListItems(
      ingredientsList,
      state.desiredAmount
    )

    setState({
      ...state,
      totalAmount: totalAmount,
      ingredientsList: ingredientsListRaw,
      scaledIngredientsList: renderIngredientsList(newIngredientsList),
    })
  }

  const handleDesiredAmountChange = (event) => {
    const desiredAmount = event.target.value
    const ingredientsList = extractIngredientsList(state.ingredientsList)
    const newIngredientsList = scaleIngredientsListItems(
      ingredientsList,
      desiredAmount
    )

    setState({
      ...state,
      desiredAmount: desiredAmount,
      scaledIngredientsList: renderIngredientsList(newIngredientsList),
    })
  }

  return (
    <Paper className={classes.paddedBox}>
      <Grid container>
        <Grid item md={5}>
          <TextField
            variant="outlined"
            value={state.totalAmount}
            label="Total"
            disabled
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">grams</InputAdornment>
              ),
            }}
          />
          <Box mt={2}></Box>
          <OutlinedInput
            variant="outlined"
            value={state.ingredientsList}
            multiline
            fullWidth
            onChange={handleIngredientListChange}
          />
        </Grid>
        <Grid item md={1}>
          <Typography variant="h4" component="p" gutterBottom align="center">
            →
          </Typography>
        </Grid>
        <Grid item md={5}>
          <TextField
            variant="outlined"
            label="Desired Amount"
            value={state.desiredAmount}
            onChange={handleDesiredAmountChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">grams</InputAdornment>
              ),
            }}
          />
          <Box mt={2}></Box>
          <OutlinedInput
            variant="outlined"
            value={state.scaledIngredientsList}
            disabled
            fullWidth
            multiline
          />
        </Grid>
      </Grid>
    </Paper>
  )
}
export default IngredientListScaler
